import type { OrderingState } from "@toema/shared-types";
import { reopensLabel } from "../lib/ordering.js";
import StatusPill from "./StatusPill.js";

interface PausedPillProps {
  ordering: OrderingState;
  timezone: string | null;
  now?: Date;
  className?: string;
}

export default function PausedPill({ ordering, timezone, now, className }: PausedPillProps) {
  const reopens = reopensLabel(ordering, timezone, now);
  return (
    <StatusPill tone="paused" className={className}>
      {reopens ? (
        <>
          Not taking orders —{" "}
          <span className="pill__keep">open again from {reopens}</span>
        </>
      ) : (
        "Not taking orders right now"
      )}
    </StatusPill>
  );
}
